class Validation {
    text = (value: string) => {
        const regex = /^[a-zA-Z0-9~._ -]*$/;
        return regex.test(value);
    };

    name = (value: string) => {
        const regex = /^[a-zA-Z]*$/;
        return regex.test(value);
    };

    number = (value: string) => {
        const regex = /^[0-9]*$/;
        return regex.test(value);
    };

    password = (value: string) => {
        const regex =
            /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-={}[\]\\|;:',.?/`~><""])[a-zA-Z0-9!@#$%^&*()_+\-={}[\]\\|;:',.?/`~><""]{8,}$/;
        return regex.test(value);
    };

    email = (value: string) => {
        const regex =
            /^([a-zA-Z\d!#$%&'*+\-/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-zA-Z\d!#$%&'*+\-/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\\x01-\\x08\\x0b\\x0c\\x0d\\x7f]|[^\0-\x7f]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-zA-Z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-zA-Z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-zA-Z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-zA-Z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][A-Za-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/;
        return regex.test(value);
    };

    domain = (value: string) => {
        const regex = /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/;
        return regex.test(value);
    };
}

export default new Validation();
